import React, { useState } from "react";
import Layout from "../form-layout";

// Router question: "Have you ever used a GLP-1/GIP weight-loss medication?"
// Sets formData.glp1History, which Home.jsx uses to pick the active step array
// (Form A / Form B / Form C).
const OPTIONS = [
  { key: "naive", label: "No, I have never used one" },
  { key: "current", label: "Yes, I am currently using one" },
  { key: "previous", label: "Yes, but I am no longer using it" },
];

export default function GLP1Router({ formData, onBack, goToStep, onRouterSelect }) {
  const [selected, setSelected] = useState(formData.glp1History || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selected) return;

    localStorage.setItem("glp1History", selected);
    // Switches Home.jsx's active step array (Form A/B/C) and the current index in one
    // go — setFormData + goToStep separately would look up the target id in the OLD
    // (still-active) step array before the glp1History state update lands.
    onRouterSelect(selected);
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-2">
        Have you ever used a GLP-1/GIP weight-loss medication?
      </h2>
      <p className="text-gray-500 mb-6 text-sm">
        This includes Mounjaro (tirzepatide), Wegovy or Ozempic (semaglutide), Saxenda (liraglutide) or
        another similar injection or tablet.
      </p>

      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        {OPTIONS.map((option) => (
          <label
            key={option.key}
            className="flex items-center gap-2 p-3 rounded-lg cursor-pointer border transition-all text-sm sm:text-[14px] font-medium text-[#000000]"
          >
            <input
              type="radio"
              name="glp1History"
              checked={selected === option.key}
              onChange={() => setSelected(option.key)}
              className="h-4 w-4 accent-sky-400 cursor-pointer"
            />
            <span>{option.label}</span>
          </label>
        ))}

        <div className="flex justify-start mt-4">
          <button
            type="submit"
            disabled={!selected}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${!selected ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"}`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
